import { Search } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import CachedIcon from "@mui/icons-material/Cached";
import { useNavigate } from "react-router-dom";
import {
  useLazyTagsListQuery,
  useLazyVendorsActiveListQuery,
} from "../../redux/api/api";

const ProductLibraryComp = ({
  method,
  getProducts,
  statusValue,
  categoryID,
  pageRow,
  searchValue,
  vendorID,
  tagID,
  productName,
  netMin,
  netMax,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [moreBtn, setMoreBtn] = useState(0);
  const [moreBtns, setMoreBtns] = useState(0);
  const [more, setMore] = useState();
  const [optionThree, setOptionThree] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const options = ["Previous Order", "Price Book Library"];
  const optionTwo = ["Customer", "Enterprises"];
  const optionFour = ["Nizam", "Logan"];

  // RTK QUERY
  const [listTagsApi] = useLazyTagsListQuery();
  const [listVendorActiveApi] = useLazyVendorsActiveListQuery();

  const onOptionChangeHandler = (e) => {
    let value = e.target.value;
    setMore(value);
    if (value == "Previous Order") {
      // window.location.reload();
      setMoreBtn(1);
    } else {
      if (value == "Price Book Library") {
        // navigate("/price-book-library", { state: { method } });
        navigate("/view-pricebook-library", { state: { method } });
      }
    }
  };

  const onOptionChangeHandlers = (e) => {
    let value = e.target.value;
    let temp = [];

    if (value == "Customer") {
      setMoreBtns(0);
      temp.push(
        "Shakthi-CMHQ001",
        "Krishna-CMHQ002",
        "Sathish-CMHQ003",
        "Viswa-CMHQ004"
      );
    } else {
      setMoreBtns(1);
      temp.push("Amazon", "Flipkart", "Ninos");
    }
    setOptionThree(temp);
    setMoreBtn(2);
  };

  const getTags = () => {
    listTagsApi()
      .unwrap()
      .then((res) => {
        let temp = res?.normalTag?.filter((i) => i?.status == 1);
        setTagList(temp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getVendor = () => {
    listVendorActiveApi()
      .unwrap()
      .then((res) => {
        setVendorList(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getTags();
    getVendor();
  }, []);

  return (
    <div className="mt-5 banner-left">
      <div className="d-flex ac-jb flex-column flex-md-row">
        <div className="d-flex ac-jc place-holde justify-content-md-start gap-3 flex-wrap w-100 mb-md-0  mb-4">
          <input
            type="text"
            className="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 px-3"
            placeholder="Product Name"
            onChange={(e) =>
              getProducts(
                searchValue,
                statusValue,
                categoryID,
                pageRow,
                e.target.value,
                vendorID,
                tagID,
                netMin,
                netMax
              )
            }
            value={productName}
          />
          <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4">
            <select
              className="bg-transparent border-0 py-3 primary1"
              onChange={(e) =>
                getProducts(
                  searchValue,
                  statusValue,
                  categoryID,
                  pageRow,
                  productName,
                  e.target.value,
                  tagID,
                  netMin,
                  netMax
                )
              }
              value={vendorID}
            >
              <option value=" ">Vendors </option>
              {vendorList?.map((item, ind) => {
                return (
                  <option key={ind} value={item?.id}>
                    {item?.legal_name}
                  </option>
                );
              })}
            </select>{" "}
          </button>
          {/* <input
            type="text"
            className="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 px-3"
            placeholder="Lead time"
          /> */}
          <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4">
            <select
              className="bg-transparent border-0 py-3 primary1"
              onChange={(e) =>
                getProducts(
                  searchValue,
                  statusValue,
                  categoryID,
                  pageRow,
                  productName,
                  vendorID,
                  e.target.value,
                  netMin,
                  netMax
                )
              }
              value={tagID}
            >
              <option value=" ">Tagged</option>
              {tagList?.map((item, ind) => {
                return (
                  <option key={ind} value={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          </button>
          <input
            type="text"
            className="get-start-btn2 respon-width  bg-lt-blue primary1 border-0 my-0 py-4 px-3"
            placeholder="Net min"
            onChange={(e) =>
              getProducts(
                searchValue,
                statusValue,
                categoryID,
                pageRow,
                productName,
                vendorID,
                tagID,
                e.target.value,
                netMax
              )
            }
            value={netMin}
          />
          <input
            type="text"
            className="get-start-btn2 respon-width  bg-lt-blue primary1 border-0 my-0 py-4 px-3"
            placeholder="Net max"
            onChange={(e) =>
              getProducts(
                searchValue,
                statusValue,
                categoryID,
                pageRow,
                productName,
                vendorID,
                tagID,
                netMin,
                e.target.value
              )
            }
            value={netMax}
          />
          <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4">
            <select className="bg-transparent border-0 py-3 primary1">
              <option value="1">Ratings </option>
              <option value="2">1</option>
              <option value="3">2</option>
              <option value="4">3</option>
              <option value="5">4</option>
              <option value="6">5</option>
            </select>
          </button>
          <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4">
            <select className="bg-transparent border-0 py-3 primary1">
              <option value="1">Type</option>
              <option value="Ecommerce">Ecommerce</option>
              <option value="Reseller">Reseller</option>
              <option value="Both">Both</option>
            </select>
          </button>
          <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 gap-3">
            <select
              onChange={onOptionChangeHandler}
              className="bg-transparent border-0 py-3 primary1"
              value={more}
            >
              <option disabled selected>
                More{" "}
              </option>
              {/* <option></option>
              <option onClick={() => console.log("sujfsnfi")}>
                
              </option> */}
              {options.map((option, index) => {
                return <option key={index}>{option}</option>;
              })}
            </select>
          </button>
          {moreBtn == 1 || moreBtn == 2 ? (
            <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 gap-3">
              <select
                onChange={onOptionChangeHandlers}
                className="bg-transparent border-0 py-3 primary1"
              >
                <option disabled selected>
                  Select Type
                </option>
                {optionTwo.map((option, index) => {
                  return <option key={index}>{option}</option>;
                })}
              </select>{" "}
            </button>
          ) : null}
          {moreBtn == 2 ? (
            <>
              <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 gap-3">
                <select
                  onChange={onOptionChangeHandlers}
                  className="bg-transparent border-0 py-3 primary1"
                >
                  <option disabled selected>
                    Select Customers{" "}
                  </option>
                  {optionThree?.map((option, index) => {
                    return <option key={index}>{option}</option>;
                  })}
                </select>
              </button>
            </>
          ) : null}
          {moreBtns == 1 && (
            <button class="get-start-btn2 respon-width bg-lt-blue primary1 border-0 my-0 py-4 gap-3">
              <select
                onChange={onOptionChangeHandlers}
                className="bg-transparent border-0 py-3 primary1"
              >
                <option disabled selected>
                  Select Customer{" "}
                </option>
                {optionFour?.map((option, index) => {
                  return <option key={index}>{option}</option>;
                })}
              </select>
            </button>
          )}
        </div>
        <div className="d-flex ac-jc gap-3">
          {/* <button
            // onClick={() => navigate("/add-vendor")}
            className="cust-btn addbtn1 d-flex ac-jc rounded-3 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 p-4 rounded"
          >
            <Search />
          </button> */}
          <button
            onClick={() => getProducts("", "", "", 20, "", "", "", "", "")}
            className="cust-btn addbtn1 d-flex ac-jc rounded-3 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 p-4 rounded"
          >
            <CachedIcon />
          </button>
        </div>
      </div>
      <div className="mt-md-3  mt-4">
        <p class=" f2 primary1 mb-0">
          Your Hourglass Essentials Pvt. Ltd. database contains products that
          you or your co-workers have added directly into commonsku. These
          products will often be Hourglass Essentials Pvt. Ltd.'s go-to
          products, preferred supplier products, or local decorators that may
          not be on commonsku otherwise.
        </p>
        <p class=" f2 primary1 mb-0">
          Enter some criteria to search for products.
        </p>
      </div>
    </div>
  );
};

export default ProductLibraryComp;
